




































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { General } from '@/services/General';
import axios from 'axios';
import { i18n } from '@/i18n/i18n-setup';

@Component
export default class EmergencyContact extends Vue {
    @Prop({ default: false })
    public isPopUp: boolean;
    @Prop({ required: false })
    public username: any;
    @Prop({ required: false, default: false })
    public isExternal: any;
    @Prop({ required: false, default: false })
    public isHrManagement: any;
    @Prop({ required: false, default: null})
    public idUserCountry: string;

    loading: boolean = true;
    name: string = '';
    surname: string = '';
    telephone: string = '';
    idCultureSelected: string = "";
    languageOptions: Array<any> = [];
    isVisibleEditable = true;
    isTelConfirmed = false;
    isCreation = false;
    isEditable: boolean = false;
    emergencyContact: any = null;
    isOnSubmit: boolean = false;

    async mounted() {    
        this.loading = true;
        if (this.username != null) {
            await this.GetEmergencyContactAsync(this.username);
        }
        else if (this.emergencyContact == null) {
            await this.GetEmergencyContactAsync();
        } else {
            this.name = this.emergencyContact.name;
            this.surname = this.emergencyContact.surname;
            this.telephone = this.emergencyContact.telephone;
            this.idCultureSelected = this.emergencyContact.idCulture;
            this.isTelConfirmed = this.emergencyContact.isTelConfirmed;
        }   

        await this.getAvailableLanguage();
        this.loading = false;
    }

    async getAvailableLanguage() {
        try {
            let response = await axios({
                method: 'get',
                url: General.GetApiUrl("/api/EmergencyContact/GetAvailablePrivacyNoticeCulture"),
                withCredentials: true,
                responseType: 'json'
            });

            this.languageOptions = response.data;
            this.languageOptions.forEach(el => {
                el.language.name = `${el.country.name} - ${el.language.name} [${el.language.code}-${el.country.code}]`
            });
            this.languageOptions.sort((a, b) => (a.country.name < b.country.name ? -1 : 1))
            this.languageOptions.unshift({ idCulture: null, language: { name: 'Please select a language' }, disabled: true },)

            let idCountryUser: string = null;
            if(this.isHrManagement)
                idCountryUser = this.idUserCountry;
            else
                idCountryUser = this.$store.getters.getUserProfile.idCountry

            if(this.languageOptions.findIndex(x => x.idCountry == idCountryUser) >= 0)
                this.languageOptions = this.languageOptions.filter(x => (x.idCountry === idCountryUser || x.idCountry == null))

        } catch (error) {
            General.showAlertDanger("Fail to load available languages for translation", this);
        }
    }
    async GetEmergencyContactAsync(username: string = null) {
        try {

            let url = username == null ? '/api/EmergencyContact/GetEmergencyContact/' : `/api/EmergencyContact/GetEmergencyContact/${username}`
            let response: any = await axios({
                method: 'GET',
                url: General.GetApiUrl(url),
                withCredentials: true,
                responseType: 'json'
            })

            if (response.data != null) {
                this.isCreation = false;
                let emergencyContact = response.data;
                this.emergencyContact = emergencyContact;
                this.name = emergencyContact.name;
                this.surname = emergencyContact.surname;
                this.telephone = emergencyContact.telephone;
                this.isTelConfirmed = emergencyContact.isTelConfirmed;
                this.idCultureSelected = emergencyContact.idCulture ?? this.$store.getters.getUserProfile.idCulture;
            } else {
                this.isCreation = true;
            }
        } catch (error) {
            General.HandleError(error, this);
        }
    }

    createEmergencyContact() {

        let validationResult = this.checkAllValues();
        this.isOnSubmit = true;

        if (validationResult) {
            let message = i18n.t('EMERGENCY.CREATE_QUESTION') as string;

            General.confirm(
                message,
                this,
                async () => {
                    await this.CreateEmergencyContactAsync();
                    this.isOnSubmit = false;
                    this.isCreation = false;
                }
            );
        }
    }


    confirmEmergencyContact() {

        let validationResult = this.checkAllValues();
        this.isOnSubmit = true;

        if (validationResult) {
            let message = i18n.t('EMERGENCY.CONFIRM_QUESTION') as string;

            General.confirm(
                message,
                this,
                async () => {
                    await this.ConfirmEmergencyContactTelephoneAsync();
                    this.isOnSubmit = false;
                }
            );
        }
    }

    UpdateEmergencyContact() {

        let validationResult = this.checkAllValues();
        this.isOnSubmit = true;

        if (validationResult) {
            let message = i18n.t('EMERGENCY.UPDATE_QUESTION') as string;

            General.confirm(
                message,
                this,
                async () => {
                    await this.UpdateEmergencyContactTelephoneAsync();
                    this.isOnSubmit = false;
                }
            );
        }
    }

    checkAllValues() {
        if (!!this.idCultureSelected && !!this.name && !!this.surname && !!this.telephone && this.isValidPhoneNumber(this.telephone)) {
            return true;
        } else {
            return false;
        }
    }

    isValidPhoneNumber(phoneNumber) {
        const pattern = /^[+]{1}(?:[0-9\-\\(\\)\\/.]\s?){6,15}[0-9]{1}$/;        
    
        if (!phoneNumber) 
            return false;
    
        if (pattern.test(phoneNumber)) {
            return true;
        } else {
            return false;
        }
    }

    getFormData() {
        let formData = new FormData();
        formData.append('IdCulture', this.idCultureSelected);
        formData.append('Name', this.name);
        formData.append('Surname', this.surname);
        formData.append('Telephone', this.telephone);
        formData.append('Username', this.username ?? '');
        return formData;
    }

    getFormDataCreation() {
        let formData = new FormData();
        formData.append('Id', null);
        formData.append('IdEmployee', null);
        formData.append('IdCulture', this.idCultureSelected);
        formData.append('Name', this.name);
        formData.append('Surname', this.surname);
        formData.append('Telephone', this.telephone);
        formData.append('Username', this.username ?? '');
        return formData;
    }

    async ConfirmEmergencyContactTelephoneAsync() {
        try {

            var formData = this.getFormData();

            await axios({
                method: 'POST',
                url: General.GetApiUrl('/api/EmergencyContact/ConfirmEmergencyContact'),
                data: formData,
                withCredentials: true,
                responseType: 'json'
            })
           
            this.$store.commit("SET_ISEMERGENCYCONTACTEXPIRED", false);
            let message = this.$t('EMERGENCY.CONFIRM_SUCCESS') as string;

            this.$bvModal.hide('bv-modal-emergency-profile')
            this.$bvModal.hide('bv-modal-emergency-info')
            this.$bvModal.hide('bv-modal-emergency-popup')

            if(this.isHrManagement)
                this.$emit('refreshSearchResults')
            
            General.showAlertSuccess(message, this);

        } catch (error) {
            General.HandleError(error, this);
        }
    }

    async UpdateEmergencyContactTelephoneAsync() {
        try {

            var formData = this.getFormData();

            await axios({
                method: 'POST',
                url: General.GetApiUrl('/api/EmergencyContact/SaveEmergencyContact'),
                data: formData,
                withCredentials: true,
                responseType: 'json'
            })
            General.GetEmergencyContactIfExpiredAsync();
            let message = this.$t('EMERGENCY.UPDATE_SUCCESS') as string;
            this.$bvModal.hide('bv-modal-emergency-profile')
            this.$bvModal.hide('bv-modal-emergency-info')
            this.$bvModal.hide('bv-modal-emergency-popup')        

            if(this.isHrManagement)
                this.$emit('refreshSearchResults')

            General.showAlertSuccess(message, this);

        } catch (error) {
            General.HandleError(error, this);
        }
    }

    PostponeRenewEmergency() {
        let message = i18n.t('EMERGENCY.POSTPONE_QUESTION') as string;

        General.confirm(
            message,
            this,
            async () => {
                await this.PostponeRenewEmergencyAsync();
            }
        );
    }

    async PostponeRenewEmergencyAsync() {
        try {
            await axios({
                method: 'POST',
                url: General.GetApiUrl('/api/EmergencyContact/PostponeRenewEmergencyContactPolicy'),
                withCredentials: true,
                responseType: 'json'
            })
            this.$store.commit("SET_ISEMERGENCYCONTACTEXPIRED", false);
            this.$bvModal.hide('bv-modal-emergency-profile')
            this.$bvModal.hide('bv-modal-emergency-info')
            this.$bvModal.hide('bv-modal-emergency-popup')
            let message = this.$t('EMERGENCY.POSTPONE_SUCCESS') as string;
            General.showAlertSuccess("Emergency contact confirmation has been postponed successfully", this);

        } catch (error) {
            General.HandleError(error, this);
        }
    }
    async CreateEmergencyContactAsync() {
        try {

            var formData = this.getFormDataCreation();

            await axios({
                method: 'POST',
                url: General.GetApiUrl('/api/EmergencyContact/Create'),
                data: formData,
                withCredentials: true,
                responseType: 'json'
            })

            this.$bvModal.hide('bv-modal-emergency-profile')
            this.$bvModal.hide('bv-modal-emergency-info')
            this.$bvModal.hide('bv-modal-emergency-popup')

            if(this.isHrManagement)
                this.$emit('refreshSearchResults')

            let message = this.$t('EMERGENCY.CREATE_SUCCESS') as string;
            General.showAlertSuccess(message, this);

        } catch (error) {
            General.HandleError(error, this);
        }
    }
    returnState(condition: boolean, clickButton: boolean): boolean {
        if (clickButton)
            return condition;
        else
            return null;
    }
}
